module.exports = __webpack_public_path__ + "img/pto.bfdff30a.svg";